import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export enum SettingName {
  ITEM_PAGE_SETTINGS = "ItemPageSettings",
  TIMEOUT_SETTINGS = "TimeoutSettings",
  INVENTORY_ORDER_WORKFLOW_ENABLED = "InventoryOrderWorkflowEnabled",
}

export interface Setting {
  settingName?: string;
  settingValue?: string;
  category?: string;
  notes?: string;
  deletedBy?: any;
  deleted?: boolean;
  deletedOnUtc?: any;
  id?: string;
  isActive?: boolean;
  createdOnUtc?: string;
  updatedOnUtc?: any;
  createdBy?: string;
  updatedBy?: any;
}

export interface SettingData {
  selectedSetting: Setting;
}

export interface SettingsState {
  systemSettings: Record<string, any>;
  isLoaded: boolean;
  selectedSetting?: Setting;
}

const initialState: SettingsState = {
  systemSettings: {},
  isLoaded: false,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSystemSettings: (state, action: PayloadAction<Record<string, any>>) => {
      state.systemSettings = action.payload;
      state.isLoaded = true;
    },
    setSelectedSetting: (state, action: PayloadAction<Setting>) => {
      state.selectedSetting = action.payload;
    },
    resetSystemSettings: (state) => {
      state.systemSettings = {};
      state.isLoaded = false;
      state.selectedSetting = undefined;
    },
  },
});

export const { setSystemSettings, setSelectedSetting, resetSystemSettings } =
  settingsSlice.actions;

export const selectSystemSettings = (state: RootState) =>
  state.settings?.systemSettings || {};

export const selectIsSettingsLoaded = (state: RootState) =>
  state.settings?.isLoaded || false;

export default settingsSlice.reducer;
